import { ARSServiceCode, BIAServiceCode, PAYServiceCode } from '@/shared/types/serviceCodes';
import { PredefinedInformerType, ExternalServiceInformers, InformersCondition } from '@/shared/ui/Informer/types';

import { SERVICE_CODES } from '@/lib/consts';

export const externalServiceInformers: ExternalServiceInformers = {
  [ARSServiceCode.CITIZEN_APPEAL_TO_MVS]: {
    '3': [
      {
        icon: {
          name: 'attention',
          color: 'red',
        },
        borderColor: 'dark-yellow',
        header: {
          text: 'Зверніть увагу!',
          color: 'red',
        },
        text: {
          text: 'Звернення, в яких буде використовуватися ненормативна лексика не будуть розглянуті.',
        },
      },
    ],
    '4': [
      {
        predefinedInformerType: PredefinedInformerType.QRCODE_DIIA,
      },
    ],
  },
  [BIAServiceCode.INSURANCE]: {
    '0': [
      {
        predefinedInformerType: PredefinedInformerType.CONTACT_CENTER,
      },
      {
        borderColor: 'dark-yellow',
        icon: {
          name: 'attention',
          color: 'red',
        },
        header: {
          text: 'Зверніть увагу!',
          color: 'red',
        },
        text: {
          text: 'В період з 23:40 до 00:05 замовлення послуги не доступне.',
        },
      },
    ],
  },
  [SERVICE_CODES.COMMISSION_SALE]: {
    '0': [
      {
        predefinedInformerType: PredefinedInformerType.CLUE,
      },
      {
        predefinedInformerType: PredefinedInformerType.VALIDITY_PERIOD_VIOLATION,
      },
      {
        predefinedInformerType: PredefinedInformerType.CONTACT_CENTER,
      },
    ],
    '1': [
      {
        predefinedInformerType: PredefinedInformerType.CONTACT_CENTER,
      },
    ],
    '2': [
      {
        predefinedInformerType: PredefinedInformerType.PLACE_OF_RESIDENCE,
      },
      {
        predefinedInformerType: PredefinedInformerType.CONTACT_CENTER,
      },
    ],
    '3': [
      {
        predefinedInformerType: PredefinedInformerType.TECHNICAL_CONDITION_DETAILS,
      },
      {
        predefinedInformerType: PredefinedInformerType.TECHNICAL_CONDITION_DOCUMENT_DATA,
      },
      {
        predefinedInformerType: PredefinedInformerType.CONTACT_CENTER,
      },
    ],
    '4': [
      {
        predefinedInformerType: PredefinedInformerType.CONTACT_CENTER,
      },
    ],
    '5': [
      {
        predefinedInformerType: PredefinedInformerType.CLUE,
      },
      {
        predefinedInformerType: PredefinedInformerType.CONTACT_CENTER,
      },
    ],
    '6': [
      {
        predefinedInformerType: PredefinedInformerType.QRCODE_DIIA,
      },
    ],
  },
  [SERVICE_CODES.RESIDENCE_RELOCATION]: {
    '0': [
      {
        predefinedInformerType: PredefinedInformerType.CLUE,
      },
      {
        predefinedInformerType: PredefinedInformerType.VALIDITY_PERIOD_VIOLATION,
      },
    ],
    '2': [
      {
        predefinedInformerType: PredefinedInformerType.PLACE_OF_RESIDENCE,
      },
    ],
    '6': [
      {
        predefinedInformerType: PredefinedInformerType.QRCODE_DIIA,
      },
    ],
  },
  [SERVICE_CODES.REAPPLICATION]: {
    '0': [
      {
        borderColor: 'dark-yellow',
        icon: {
          name: 'attention',
          color: 'red',
        },
        header: {
          text: 'Зверніть увагу!',
          color: 'red',
        },
        text: {
          text: 'Ви можете подати заяву на відновлення руху один раз для кожної окремої заяви. Якщо заява знаходиться в процесі розгляду, ви не можете ініціювати для неї поновлення руху повторно.',
        },
      },
    ],
    '4': [
      {
        predefinedInformerType: PredefinedInformerType.QRCODE_DIIA,
      },
    ],
  },
  [PAYServiceCode.PAYMENT_WITHOUT_APPLICATION]: {
    '0': [
      {
        borderColor: 'dark-yellow',
        icon: {
          name: 'attention',
          color: 'red',
        },
        header: {
          text: 'Увага!',
          color: 'red',
        },
        text: {
          text: 'Якщо ви спалачуєте не за себе, ви маєте вказувати дані тієї особи за яку проводиться платіж.',
        },
      },
    ],
    '1': [
      {
        predefinedDisplayCondition: InformersCondition.IS_NOT_LOGGED_IN,
        borderColor: 'red',
        icon: {
          name: 'attention',
          color: 'red',
        },
        header: {
          text: 'Зверніть увагу!',
          color: 'red',
        },
        text: {
          text: 'Єдине вікно не несе відповідальності за вашу оплату, поки ви не авторизуєтесь в системі',
        },
      },
    ],
  },
  [SERVICE_CODES.MISSING_PERSON_EXTRACT]: {
    '0': [
      {
        borderColor: 'blue',
        icon: {
          name: 'attention',
          color: 'blue',
        },
        header: {
          text: 'Виникли проблеми з заповненням запиту?',
          color: 'blue',
        },
        text: {
          text: 'Ознайомтесь з покроковою відеоінструкцією',
        },
        linkKey: 'serviceInformer.missingPersonExtractVideoInstruction',
        linkText: 'Відеоінструкція',
      },
    ],
    '2': [
      {
        icon: {
          name: 'attention',
          color: 'blue',
        },
        borderColor: 'blue',
        header: {
          text: 'Зверніть увагу!',
          color: 'blue',
        },
        text: {
          text: 'У разі зміни прізвища або інших даних, які різняться між посвідченням особи заявника та свідоцтвом, то необхідно підтвердження про їх зміну',
        },
      },
    ],
    '3': [
      {
        predefinedInformerType: PredefinedInformerType.QRCODE_DIIA,
      },
    ],
  },
  [SERVICE_CODES.COLD_STEEL_STORAGE_FOR_COLLECTION]: {
    '0': [
      {
        predefinedInformerType: PredefinedInformerType.PAYMENT_DETAILS,
      },
      {
        predefinedInformerType: PredefinedInformerType.CLUE,
      },
    ],
    '5': [
      {
        borderColor: 'dark-yellow',
        icon: {
          name: 'attention',
          color: 'red',
        },
        header: {
          text: 'Увага!',
          color: 'red',
        },
        text: {
          text: `Поліцейські, працівники інших державних правоохоронних органів,
          державних органів спеціального призначення з правоохоронними функціями,
          військовослужбовці Збройних Сил України, інших військових формувань,
          крім військовослужбовців, які проходять строкову військову службу подають
          довідку про вивчення матеріальної частини зброї або копії відповідного
          документа про закріплення вогнепальної зброї`,
        },
      },
    ],
    '7': [
      {
        predefinedInformerType: PredefinedInformerType.QRCODE_DIIA,
      },
    ],
    '8': [
      {
        predefinedInformerType: PredefinedInformerType.PAYMENT_OFFLINE,
      },
      {
        predefinedInformerType: PredefinedInformerType.PAYMENT_ONLINE,
      },
    ],
  },
  [SERVICE_CODES.EXTENDED_CRIMINAL_RECORD_EXTRACT]: {
    '0': [
      {
        predefinedInformerType: PredefinedInformerType.HAS_ACTIVE_REQUEST,
      },
      {
        predefinedInformerType: PredefinedInformerType.PAPER_EXTRACT_DISABLED,
      },
      {
        predefinedInformerType: PredefinedInformerType.ELECTRONIC_EXTRACT_DISABLED,
      },
    ],
    '1': [
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_ELECTRONIC,
      },
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_PAPER,
      },
    ],
    '2': [
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_ELECTRONIC,
      },
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_PAPER,
      },
    ],
    '3': [
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_ELECTRONIC,
      },
      {
        borderColor: 'dark-yellow',
        icon: {
          name: 'attention',
          color: 'red',
        },
        header: {
          text: 'Зверніть увагу!',
          color: 'red',
        },
        text: {
          text: `Апостилювання витягу платне.
            <br/>
            Апостиль - це міжнародний штамп, що підтверджує законність витягу, необхідного для використання за кордоном,
            в країнах-учасницях Гаазької конвенції. Він засвідчує справжність підпису особи, що підписала витяг,
            та автентичність печатки або штампа, якими скріплений витяг.`,
        },
        formValueConditions: {
          extractFormType: 'PAPER',
        },
      },
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_PAPER,
      },
      {
        icon: {
          name: 'attention',
          color: 'blue',
        },
        borderColor: 'blue',
        header: {
          text: 'Зверніть увагу!',
          color: 'blue',
        },
        text: {
          text: 'Витяг про несудимість буває "повним" та "скороченим". Скорочений витяг містить лише інформацію про відсутність або наявність судимості. Повний витяг, окрім інформації про відсутність або наявність судимості, включає відомості про притягнення до кримінальної відповідальності та інші обмеження, передбачені кримінальним процесуальним законодавством.',
        },
      },
    ],
    '4': [
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_ELECTRONIC,
      },
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_PAPER,
      },
      {
        borderColor: 'dark-yellow',
        icon: {
          name: 'attention',
          color: 'red',
        },
        header: {
          text: 'Зверніть увагу!',
          color: 'red',
        },
        text: {
          text: 'Через те, що ви не маєте власного РНОКПП, ви не можете замовити адресну доставку Укрпоштою',
        },
        formValueConditions: {
          extractFormType: 'PAPER',
          canBeDeliveredToAddress: false,
        },
      },
    ],
    '5': [
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_ELECTRONIC,
      },
      {
        predefinedInformerType: PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_PAPER,
      },
    ],
    '6': [
      {
        predefinedInformerType: PredefinedInformerType.QRCODE_DIIA,
      },
    ],
  },
  [SERVICE_CODES.COLD_STEEL_TRANSPORTATION]: {
    '7': [
      {
        predefinedInformerType: PredefinedInformerType.QRCODE_DIIA,
      },
    ],
  },
  [SERVICE_CODES.TEMPORARY_RESIDENCE_RELOCATION]: {
    '0': [
      {
        predefinedInformerType: PredefinedInformerType.CLUE,
      },
      {
        predefinedInformerType: PredefinedInformerType.VALIDITY_PERIOD_VIOLATION,
      },
    ],
    '2': [
      {
        predefinedInformerType: PredefinedInformerType.PLACE_OF_RESIDENCE,
      },
    ],
    '5': [
      {
        predefinedInformerType: PredefinedInformerType.QRCODE_DIIA,
      },
    ],
  },
  [SERVICE_CODES.PURCHASE]: {
    '0': [
      {
        predefinedInformerType: PredefinedInformerType.PAYMENT_DETAILS,
      },
    ],
    '1': [
      {
        predefinedInformerType: PredefinedInformerType.PERSON_STATUS,
      },
    ],
    '2': [
      {
        predefinedInformerType: PredefinedInformerType.LEARNING_DOCUMENT,
      },
    ],
  },
};
